@if(onlyInput()){
    <form>
        <mat-form-field class="custom-chip-field w-100" appearance="outline">
            @if(multi()){
                <mat-chip-grid #chipGrid>
                    @for(option of selectedOptions; track option.id){
                        <mat-chip-row
                            [removable]="true"
                            (removed)="removeOption(option)"
                            class="compact-chip"
                        >
                            <!-- Main chip content -->
                            <span class="chip-text">{{ option.name }}</span>
                            
                            <!-- Action buttons on the right -->
                            <div class="chip-actions">
                                @if(enableDetailNavigation()) {
                                    <button 
                                        type="button"
                                        class="chip-action-btn view-btn"
                                        (click)="onSelectedOptionClick(option, $event)"
                                        matTooltip="View details"
                                    >
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                }
                                <button 
                                    type="button"
                                    class="chip-action-btn remove-btn"
                                    (click)="onChipRemoveClick(option, $event)"
                                    matTooltip="Remove"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input
                    type="text"
                    matInput
                    [matChipInputFor]="chipGrid"
                    placeholder="{{ label() }}"
                    [formControl]="firstControl"
                    [matAutocomplete]="auto"
                />
            }@else{
                <div style="position: relative;">
                    <input
                        type="text"
                        matInput
                        placeholder="{{ label() }}"
                        [formControl]="firstControl"
                        [matAutocomplete]="auto"
                        [style.padding-right]="shouldShowActions() ? '80px' : '12px'"
                    />
                    
                    <!-- Action buttons for single select - shown as part of input -->
                    @if(shouldShowActions()) {
                        <div class="input-suffix-actions">
                            <button 
                                type="button"
                                class="input-action-btn view-btn"
                                (click)="onSelectedOptionClick(getActionOption(), $event)"
                                matTooltip="View details"
                                aria-label="View details"
                            >
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button 
                                type="button"
                                class="input-action-btn clear-btn"
                                (click)="clearSelection()"
                                matTooltip="Clear selection"
                                aria-label="Clear selection"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    }
                </div>
            }
            
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @if(options()?.length){
                    <mat-option
                        *ngFor="let option of options()"
                        [value]="option"
                        (click)="onOptionSelected(option)"
                    >
                        {{ option.name }}
                    </mat-option>
                }
                @else{
                    <mat-option disabled>
                        No results found
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
    </form>
} @else {
    <div class="col-sm-6">
        <mat-card class="b-1 shadow-none">
            <mat-card-header>
                <mat-card-title>First autocomplete option</mat-card-title>
            </mat-card-header>
            <mat-card-content class="b-t-1">
                <form>
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>{{ label() }}</mat-label>
                        @if(shouldShowActions()) {
                            <div class="input-suffix-actions">
                                <button 
                                    type="button"
                                    class="input-action-btn view-btn"
                                    (click)="onSelectedOptionClick(getActionOption(), $event)"
                                    matTooltip="View details"
                                    aria-label="View details"
                                >
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button 
                                    type="button"
                                    class="input-action-btn clear-btn"
                                    (click)="clearSelection()"
                                    matTooltip="Clear selection"
                                    aria-label="Clear selection"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        }
                        <input
                            type="text"
                            placeholder="Pick one"
                            matInput
                            [formControl]="firstControl"
                            [matAutocomplete]="auto"
                        />
                        <mat-autocomplete
                            #auto="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            @for(option of options(); track option.id) {
                                <mat-option
                                    [value]="option"
                                    (click)="onOptionSelected(option)"
                                >
                                    {{ option.name }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
}